import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { OmegaDetailModalComponent } from '../../shared/components/omega/omega-details-update-modal.component';
import { ValidationResultsModule } from '../../shared/components/validation-results/validation-results.module';
import { SharedDirectivesModule } from '../../shared/directives/shared-directives.module';
import { MVMSpinnerBtnModule } from '../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { CustomerNameModalComponent } from './customer-name-modal.component';
import { CustomerNameComponent } from './customer-name.component';
import { CustomerNamesAkaComponent } from './customer-names-aka.component';
import { CustomerNamesComponent } from './customer-names.component';

@NgModule({
    declarations: [
        CustomerNamesAkaComponent,
        CustomerNamesComponent,
        CustomerNameModalComponent,
        CustomerNameComponent
    ],
    providers: [],
    imports: [
        CommonModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedDirectivesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerNamesAkaComponent,
        CustomerNamesComponent,
        CustomerNameModalComponent,
        CustomerNameComponent
    ]
})

export class CustomerNamesModule {}
